export default __webpack_public_path__ + "static/media/RecipesMockup.98351da5.png";